<div class="reader-wrapper">
    <div class="reader-header">
        <a [routerLink]="['/charger-home']">
            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.292893 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538408 7.04738 0.538408 6.65685 0.928933L0.292893 7.29289ZM14 7L1 7L1 9L14 9L14 7Z"
                    fill="white" />
            </svg>
        </a>
        <span>QR Scanner</span>
    </div>
    <div id="reader"></div>
    <!-- <footer class="web-footer">
        <a href="https://ezy-charge.com/about-us.php" target="_blank" style="color: #00796a;">About Us</a>
        <a href="https://ezy-charge.com/contact.php" target="_blank" style="color: #00796a;">Contact Us</a>
        <a href="https://ezy-charge.com/privacy-policy.php" target="_blank" style="color: #00796a;">Privacy & Policy</a>
        <a href="https://ezy-charge.com/refund-cancellation-policy.php" target="_blank" style="color: #00796a;">Refund & Cancellation Policy</a>
    </footer> -->
</div>